/**
 * Mockup Parallax Interactivity
 * Shopify-compatible parallax effect for product mockup
 */

document.addEventListener('DOMContentLoaded', function() {
  const mockup = document.getElementById('mockup');
  const wrap = document.querySelector('.mockup-wrap');

  if (!mockup || !wrap) {
    console.warn('Mockup elements not found');
    return;
  }

  wrap.addEventListener('mousemove', function(e) {
    const r = wrap.getBoundingClientRect();
    const dx = (e.clientX - (r.left + r.width / 2)) / r.width;
    const dy = (e.clientY - (r.top + r.height / 2)) / r.height;

    mockup.style.transform = `rotateX(${(-dy * 8).toFixed(2)}deg) rotateY(${(dx * 10).toFixed(2)}deg) translateZ(6px)`;
  });

  wrap.addEventListener('mouseleave', function() {
    mockup.style.transform = 'rotateX(0) rotateY(0) translateZ(0)';
  });

  // Touch support for mobile
  wrap.addEventListener('touchmove', function(e) {
    if (e.touches.length > 0) {
      const touch = e.touches[0];
      const r = wrap.getBoundingClientRect();
      const dx = (touch.clientX - (r.left + r.width / 2)) / r.width;
      const dy = (touch.clientY - (r.top + r.height / 2)) / r.height;

      mockup.style.transform = `rotateX(${(-dy * 4).toFixed(2)}deg) rotateY(${(dx * 5).toFixed(2)}deg) translateZ(3px)`;
    }
  });

  wrap.addEventListener('touchend', function() {
    mockup.style.transform = 'rotateX(0) rotateY(0) translateZ(0)';
  });
});
